import { ApplicationRef, NgZone } from '@angular/core';
import { Observable } from 'rxjs';
import { StorageHandler } from './storage-handler.class';

export class WebStorageService {
    static _instance: Map<string, WebStorageService> = new Map();

    protected _handler: StorageHandler;
    protected _cache: Map<string, any>;

    constructor(private _storage: Storage, protected _aref: ApplicationRef, protected _zone: NgZone) {
        const type = _storage === localStorage ? 'local' : 'session';

        if (WebStorageService._instance.get(type)) {
            return WebStorageService._instance.get(type);
        }
        WebStorageService._instance.set(type, this);

        this._handler = new StorageHandler(_storage);
        this._cache = new Map();

        this._handler.getKey$().subscribe((key: string) => {
            if (this._handler.isFullKey(key)) {
                this.get$(key).subscribe(data => {
                    const _cacheData = this._cache.get(key);
                    if (!_cacheData || _cacheData !== data) {
                        this._cache.set(key, data);
                        this._zone.run(() => {
                            this._aref.tick();
                        });
                    }
                });
            }
        });
    }

    get$(key: string): Observable<any> {
        let fullkey: string;
        fullkey = this._handler.isFullKey(key) ? key : this._handler.generateStorageKey(key);

        if (!this._handler.exists(fullkey)) {
            this._handler.set(fullkey, '');
        }
        return this._handler.get$(fullkey);
    }

    get(key: string): any {
        return this._handler.get(key);
    }

    set(key: string, value: any): void {
        this._handler.set(key, value);
    }

    remove(key: string): void {
        this._handler.remove(key);
    }

    clear(): void {
        this._storage.clear();
    }
}
